import env from '@polleverywhere/core/lib/env'

env.set({
  agave_url: `${process.env.AGAVE_URL}`,
  aftermath_url: `${process.env.AFTERMATH_URL}`,
  api_url: `${process.env.API_URL}`,
  api_server_url: `${process.env.API_SERVER_URL}`,
  auth_fqdn: `${process.env.AUTH_FQDN}`,
  cdn_url: `${process.env.CDN_URL}`,
  cutlass_base_url: `${process.env.CUTLASS_BASE_URL}`,
  firehose_ssl: JSON.parse(process.env.FIREHOSE_SSL),
  firehose_url: `${process.env.FIREHOSE_URL}`,
  google_sso_web_client_id: `${process.env.GOOGLE_SSO_WEB_CLIENT_ID}`,
  google_tag_manager_id: `${process.env.GOOGLE_TAG_MANAGER_ID}`,
  graphql_url: `${process.env.GRAPHQL_URL}`,
  participant_fqdn: `${process.env.PARTICIPANT_FQDN}`,
  mobile_url: `${process.env.MOBILE_URL}`,
  embed_fqdn: `${process.env.EMBED_FQDN}`,
  feedback_participant_key: `${process.env.FEEDBACK_PARTICIPANT_KEY}`,
  opt_out_feedback_participant_key: `${process.env.OPT_OUT_FEEDBACK_PARTICIPANT_KEY}`,
  presenter_redirect_enabled: JSON.parse(process.env.PRESENTER_REDIRECT_ENABLED || false),
  proxy_enabled: JSON.parse(process.env.PROXY_ENABLED),
  proxy_xdomain_api: JSON.parse(process.env.PROXY_XDOMAIN_API),
  rollbar_access_token: `${process.env.ROLLBAR_ACCESS_TOKEN}`,
  rollbar_environment: `${process.env.ROLLBAR_ENVIRONMENT}`,
  root_url: `${process.env.ROOT_URL}`,
  singularity_url: `${process.env.SINGULARITY_URL}`,
  slide_server_url: `${process.env.SLIDE_SERVER_URL}`,
  typekit_id: `${process.env.TYPEKIT_ID}`,
  viz_url: `${process.env.VIZ_URL}`
})
